import React from 'react';
import { Route, IndexRoute, Router, } from 'react-router';

// Containers
import App from './containers/App/'
import QRImage from './containers/App/QRImage/'
import Audit from './containers/App/Audit/'
import Pages from './containers/Pages/'
import Dashboard from './components/Dashboard/'

import Login from './containers/Pages/Login/'
import RegisterUser from './containers/App/User/RegisterUser/'
import User from './containers/App/User/'
import RegisterCustomer from './containers/App/Customer/RegisterCustomer/'
import Score from './containers/App/Score/Score'
import ScoreExchange from './containers/App/Score/ScoreExchange'
import ScoreLog from './containers/App/Score/ScoreLog'
import newTasks from './containers/App/Tasks/newTasks'
import queryTasks from './containers/App/Tasks/queryTasks'

const Routers = ({ history }) => (
  <Router history={history}>
    <Route path="/" name="Home" component={App}>
      <IndexRoute component={Dashboard} />
      <Route path="dashboard" name="Dashboard" component={Dashboard} />
      <Route path="basic" name="Basic" component={Dashboard} />
      <Route path="advanced" name="Advanced" component={Dashboard} />
      <Route path="qrimage" name="QRImage" component={QRImage} />
      <Route path="audit" name="QRImage" component={Audit} />
      <Route path="user" name="user" component={User} />
      <Route path="register/user" name="Register user" component={RegisterUser} />
      <Route path="register/customer" name="Register customer" component={RegisterCustomer} />
      <Route path="score" name="user" component={Score} />
      <Route path="score/exchange" name="user" component={ScoreExchange} />
      <Route path="score/log" name="user" component={ScoreLog} />
      <Route path="newTasks" name="newTasks" component={newTasks} />
      <Route path="queryTasks" name="queryTasks" component={queryTasks} />
    </Route>
    <Route path="pages/" name="Pages" component={Pages}>
      {/**
      <IndexRoute component={Page404}/>
      */}
      {/* <Route path="main" name="Login Page" component={Main} /> */}
      <Route path="login" name="Login Page" component={Login} />
      {/**
      <Route path="register" name="Register Page" component={Register}/>
      <Route path="404" name="Page 404" component={Page404}/>
      <Route path="500" name="Page 500" component={Page500}/>
      */}
    </Route>
  </Router>
)

export default Routers



// WEBPACK FOOTER //
// ./routes.js